







































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
@Component({
  components: {}
})
export default class AreaModal extends Vue {
  @Prop({ type: Array, default: () => [] })
  areaList!: string[]

  // 是否使用行内样式
  @Prop({ type: Boolean, default: true })
  inline: boolean

  showModal = false
  provinceList = [
    {
      area: '华东',
      valueList: ['上海市', '江苏省', '浙江省', '安徽省', '江西省']
    },
    {
      area: '华北',
      valueList: [
        '北京市',
        '天津市',
        '山西省',
        '河北省',
        '内蒙古自治区',
        '山东省'
      ]
    },
    { area: '华中', valueList: ['河南省', '湖北省', '湖南省'] },
    {
      area: '华南',
      valueList: ['广东省', '广西壮族自治区', '海南省', '福建省']
    },
    {
      area: '西南',
      valueList: ['四川省', '贵州省', '云南省', '重庆市', '西藏自治区']
    },
    {
      area: '西北',
      valueList: [
        '陕西省',
        '甘肃省',
        '青海省',
        '宁夏回族自治区',
        '新疆维吾尔自治区'
      ]
    },
    { area: '东北', valueList: ['黑龙江省', '吉林省', '辽宁省'] },
    {
      area: '港澳台',
      valueList: ['香港特别行政区', '澳门特别行政区', '台湾省']
    }
  ]
  selectArea = []

  created() {}

  showFn() {
    this.selectArea = JSON.parse(JSON.stringify(this.areaList))
    this.showModal = true
  }

  /**
   * 添加一个地区的省份
   */
  addAreaFn(row) {
    let isnoHave = 0
    row.valueList.forEach(item => {
      if (this.selectArea.indexOf(item) > -1) {
        isnoHave++
      }
    })
    if (isnoHave < row.valueList.length) {
      row.valueList.forEach(item => {
        if (this.selectArea.indexOf(item) == -1) {
          this.selectArea.push(item)
        }
      })
    } else {
      row.valueList.forEach(item => {
        this.selectArea.forEach((child, index) => {
          if (child == item) {
            this.selectArea.splice(index, 1)
          }
        })
      })
    }
  }

  ok() {
    this.$emit('areaChange', this.selectArea)
    this.cancel()
  }

  cancel() {
    this.showModal = false
    this.selectArea = []
  }
}
